export default __webpack_public_path__ + "static/media/TelegramIcon.98e69f8e.svg";